"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4994],{

/***/ 72097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconImageClose/index.js
var IconImageClose = __webpack_require__(81485);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/hooks/useShowFooter.js
function useShowFooter(props) {
    var title = props.title, description = props.description, actions = props.actions;
    var showCaption = title || description;
    var showActions = actions && actions.length;
    var showFooter = showCaption || showActions;
    return [showFooter, showCaption, showActions];
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMore/index.js
var IconMore = __webpack_require__(47962);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/trigger-for-toolbar.js
var trigger_for_toolbar = __webpack_require__(82411);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image-footer.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





var ImageFooter = function (props) {
    var _a;
    var style = props.style, className = props.className, title = props.title, description = props.description, actions = props.actions, prefixCls = props.prefixCls, simple = props.simple;
    var _b = __read(useShowFooter({ title: title, description: description, actions: actions }), 3), showFooter = _b[0], showCaption = _b[1], showActions = _b[2];
    if (!showFooter)
        return null;
    var footerPrefixCls = prefixCls + "-footer";
    var classNames = (0,_util_classNames/* default */.Z)(footerPrefixCls, className, (_a = {},
        _a[footerPrefixCls + "-with-actions"] = showActions,
        _a));
    var renderActionList = function () {
        var actionsList = (react.createElement("div", { className: prefixCls + "-actions-list" }, actions.map(function (item, index) {
            return (react.createElement("div", { className: prefixCls + "-actions-item", key: "" + index }, item));
        })));
        if (simple) {
            return (react.createElement("div", { className: prefixCls + "-actions-list" },
                react.createElement(trigger_for_toolbar/* TriggerForToolbar */.y, { prefixCls: prefixCls, popup: function () { return actionsList; } },
                    react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-actions-item", prefixCls + "-actions-item-trigger") },
                        react.createElement("span", null,
                            react.createElement(IconMore/* default */.Z, null))))));
        }
        return actionsList;
    };
    return (react.createElement("div", { className: classNames, style: style },
        showCaption && (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(footerPrefixCls + "-block", prefixCls + "-caption") },
            title && (react.createElement("div", { className: prefixCls + "-caption-title", title: title }, title)),
            description && !simple && (react.createElement("div", { className: prefixCls + "-caption-description", title: description }, description)))),
        showActions && (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(footerPrefixCls + "-block", prefixCls + "-actions") }, renderActionList()))));
};

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview.js + 4 modules
var image_preview = __webpack_require__(88765);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview-group.js
var image_preview_group = __webpack_require__(65808);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/utils/hooks/useImageStatus.js
var useImageStatus = __webpack_require__(83062);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/previewGroupContext.js
var previewGroupContext = __webpack_require__(83417);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIntersectionObserver.js



var supportIntersectionObserver = !dom/* isServerRendering */.ET && !(0,is/* isUndefined */.o8)(window === null || window === void 0 ? void 0 : window.IntersectionObserver);
function useIntersectionObserver(callback, options) {
    if (options === void 0) { options = {}; }
    var intersectionObserver = (0,react.useRef)();
    var destroyObserver = function () {
        if (intersectionObserver.current) {
            intersectionObserver.current.disconnect();
            intersectionObserver.current = null;
        }
    };
    var createObserver = function (elem) {
        if (elem) {
            destroyObserver();
            if (supportIntersectionObserver) {
                intersectionObserver.current = new IntersectionObserver(callback, options);
                intersectionObserver.current.observe(elem);
            }
        }
    };
    return {
        observer: intersectionObserver.current,
        cor: createObserver,
        dor: destroyObserver,
    };
}
/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useInView.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var useInView_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


function useInView(props) {
    var defaultInView = props.defaultInView, _a = props.unobserverOnEnter, unobserverOnEnter = _a === void 0 ? true : _a, onChange = props.onChange, target = props.target, rest = __rest(props, ["defaultInView", "unobserverOnEnter", "onChange", "target"]);
    // if intersect observer is not supported
    var _b = useInView_read((0,react.useState)(supportIntersectionObserver ? defaultInView : true), 2), inView = _b[0], setInView = _b[1];
    var observerCallback = (0,react.useCallback)(function (_a, observer) {
        var _b = useInView_read(_a, 1), entry = _b[0];
        var inThreshold = observer.thresholds.some(function (t) { return entry.intersectionRatio >= t; });
        var newInView = inThreshold && entry.isIntersecting;
        setInView(newInView);
        onChange === null || onChange === void 0 ? void 0 : onChange(newInView, entry);
        if (newInView && unobserverOnEnter) {
            observer.unobserve(entry.target);
        }
    }, [onChange, unobserverOnEnter]);
    var _c = hooks_useIntersectionObserver(observerCallback, rest), cor = _c.cor, dor = _c.dor, observer = _c.observer;
    (0,react.useEffect)(function () {
        var noNeedObserver = defaultInView && unobserverOnEnter;
        if (noNeedObserver) {
            dor();
        }
        else if (target) {
            cor(target);
        }
        return dor;
    }, [target, defaultInView, unobserverOnEnter]);
    return {
        inView: inView,
        observer: observer,
    };
}
/* harmony default export */ var hooks_useInView = (useInView);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/image.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var image_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var image_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

















var uuid = 0;
var defaultProps = {
    footerPosition: 'inner',
    preview: true,
};
function Image(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Image);
    var style = props.style, className = props.className, src = props.src, width = props.width, height = props.height, title = props.title, description = props.description, actions = props.actions, footerPosition = props.footerPosition, simple = props.simple, loader = props.loader, loaderClassName = props.loaderClassName, error = props.error, preview = props.preview, _propsPreviewProps = props.previewProps, alt = props.alt, onClick = props.onClick, index = props.index, _index = props._index, onError = props.onError, onLoad = props.onLoad, lazyload = props.lazyload, restProps = image_rest(props, ["style", "className", "src", "width", "height", "title", "description", "actions", "footerPosition", "simple", "loader", "loaderClassName", "error", "preview", "previewProps", "alt", "onClick", "index", "_index", "onError", "onLoad", "lazyload"]);
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var _c = (0,react.useContext)(previewGroupContext/* PreviewGroupContext */.v), previewGroup = _c.previewGroup, handleGroupVisibleChange = _c.handleVisibleChange, registerPreviewUrl = _c.registerPreviewUrl, registerPreviewProps = _c.registerPreviewProps, setCurrentIndex = _c.setCurrentIndex;
    var previewProps = (0,react.useMemo)(function () {
        return (0,is/* isObject */.Kn)(_propsPreviewProps) ? _propsPreviewProps : {};
    }, [_propsPreviewProps]);
    var intersectionInitOptions = (0,react.useMemo)(function () {
        return (0,is/* isObject */.Kn)(lazyload) ? lazyload : {};
    }, [lazyload]);
    var id = (0,react.useMemo)(function () {
        if ((0,is/* isNumber */.hj)(index) || (0,is/* isNumber */.hj)(_index)) {
            uuid = (0,is/* isNumber */.hj)(index) ? index : _index;
            return uuid;
        }
        return uuid++;
    }, []);
    var previewSrc = previewProps.src || src;
    var _d = image_read(useShowFooter({ title: title, description: description, actions: actions }), 1), showFooter = _d[0];
    var _e = (0,useImageStatus/* default */.Z)('beforeLoad'), isLoading = _e.isLoading, isError = _e.isError, isLoaded = _e.isLoaded, isLazyLoad = _e.isLazyLoad, isBeforeLoad = _e.isBeforeLoad, setStatus = _e.setStatus;
    var _f = image_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: previewProps.defaultVisible,
        value: previewProps.visible,
    }), 2), previewVisible = _f[0], setPreviewVisible = _f[1];
    // Props passed directly into Preview component
    var availablePreviewProps = (0,react.useMemo)(function () {
        return (0,omit/* default */.Z)(previewProps, ['visible', 'defaultVisible', 'src', 'onVisibleChange']);
    }, [previewProps]);
    var prefixCls = getPrefixCls('image');
    var isControlled = !(0,is/* isUndefined */.o8)(previewProps.visible);
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-rtl"] = rtl,
        _a[prefixCls + "-simple"] = simple,
        _a[prefixCls + "-before-load"] = isBeforeLoad,
        _a[prefixCls + "-loading"] = isLoading,
        _a[prefixCls + "-loading-error"] = isError,
        _a[prefixCls + "-with-footer-inner"] = isLoaded && showFooter && footerPosition === 'inner',
        _a[prefixCls + "-with-footer-outer"] = isLoaded && showFooter && footerPosition === 'outer',
        _a[prefixCls + "-with-preview"] = isLoaded && preview && !isError && !isControlled,
        _a), className);
    var refImg = (0,react.useRef)();
    function onImgLoaded(e) {
        setStatus('loaded');
        onLoad && onLoad(e);
    }
    function onImgLoadError(e) {
        setStatus('error');
        onError && onError(e);
    }
    function onImgClick(e) {
        if (preview && previewGroup) {
            setCurrentIndex(id);
            handleGroupVisibleChange(true);
        }
        else if (preview) {
            togglePreviewVisible(true);
        }
        onClick && onClick(e);
    }
    function togglePreviewVisible(newVisible) {
        previewProps.onVisibleChange && previewProps.onVisibleChange(newVisible, previewVisible);
        setPreviewVisible(newVisible);
    }
    var inView = hooks_useInView(__assign({ target: refImg.current, defaultInView: !lazyload }, intersectionInitOptions)).inView;
    (0,react.useEffect)(function () {
        if (refImg.current) {
            if (inView) {
                // avoid set img.src to undefined when its doesn't have [src] attribute
                if ((refImg.current.src || src) && refImg.current.src !== src) {
                    refImg.current.src = src;
                    setStatus('loading');
                }
            }
            else {
                setStatus('lazyload');
            }
        }
    }, [src, inView]);
    (0,react.useEffect)(function () {
        if (!previewGroup)
            return;
        var unRegister = registerPreviewProps(id, availablePreviewProps);
        return function () { return unRegister(id); };
    }, [id, previewGroup, availablePreviewProps]);
    (0,react.useEffect)(function () {
        if (!previewGroup)
            return;
        var unRegister = registerPreviewUrl(id, previewSrc, preview);
        return function () { return unRegister(id); };
    }, [id, previewGroup, previewSrc, preview]);
    var defaultError = (react.createElement("div", { className: prefixCls + "-error" },
        react.createElement("div", { className: prefixCls + "-error-icon" },
            react.createElement(IconImageClose/* default */.Z, null)),
        alt && react.createElement("div", { className: prefixCls + "-error-alt" }, alt)));
    var defaultLoader = (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-loader", loaderClassName) },
        react.createElement("div", { className: prefixCls + "-loader-spin" },
            react.createElement(IconLoading/* default */.Z, null),
            react.createElement("div", { className: prefixCls + "-loader-spin-text" }, "Loading"))));
    var renderLoader = function () {
        if (loader === true)
            return defaultLoader;
        var loadElem = loader || defaultLoader;
        // 懒加载展示占位。
        if (lazyload || loader) {
            return loadElem;
        }
        return null;
    };
    return (react.createElement("div", { className: classNames, style: Object.assign({ width: width, height: height }, style), ref: ref },
        react.createElement("img", __assign({ ref: refImg, className: prefixCls + "-img", tabIndex: 0 }, getKeyboardEvents({
            onPressEnter: onImgClick,
        }), restProps, (lazyload || src === undefined ? {} : { src: src }), { title: title, width: width, height: height, onLoad: onImgLoaded, onError: onImgLoadError, onClick: onImgClick, alt: alt })),
        !isLoaded && (react.createElement("div", { className: prefixCls + "-overlay" },
            isError && (error || defaultError),
            (isLoading || isLazyLoad) && renderLoader())),
        isLoaded && showFooter && (react.createElement(ImageFooter, { title: title, description: description, actions: actions, prefixCls: prefixCls, simple: simple })),
        isLoaded && preview && (react.createElement(image_preview/* default */.Z, __assign({ visible: previewVisible, src: previewSrc }, availablePreviewProps, { onVisibleChange: togglePreviewVisible })))));
}
var RefImageComponent = react.forwardRef(Image);
var ImageComponent = RefImageComponent;
ImageComponent.Preview = image_preview/* default */.Z;
ImageComponent.PreviewGroup = image_preview_group/* default */.Z;
ImageComponent.displayName = 'Image';
/* harmony default export */ var Image_image = (ImageComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Image/index.js

/* harmony default export */ var es_Image = (Image_image);


/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

const hasIntersectionObserver = typeof IntersectionObserver === 'function';
const observers = new Map();
const idList = [];

function createObserver(options) {
  const id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  const existing = idList.find(obj => obj.root === id.root && obj.margin === id.margin);
  let instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  const elements = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const callback = elements.get(entry.target);
      const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id,
    observer,
    elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  const {
    id,
    observer,
    elements
  } = createObserver(options);
  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements.delete(element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers.delete(id);
      const index = idList.findIndex(obj => obj.root === id.root && obj.margin === id.margin);

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  let {
    rootRef,
    rootMargin,
    disabled
  } = _ref;
  const isDisabled = disabled || !hasIntersectionObserver;
  const [visible, setVisible] = (0, _react).useState(false);
  const [element, setElement] = (0, _react).useState(null);
  (0, _react).useEffect(() => {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        const unobserve = observe(element, isVisible => isVisible && setVisible(isVisible), {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        const idleCallback = (0, _requestIdleCallback).requestIdleCallback(() => setVisible(true));
        return () => (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  const resetVisible = (0, _react).useCallback(() => {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 51566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72097);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1405);
/* harmony import */ var _assets_shop2x_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81186);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


const _excluded = ["errorSrc", "src", "preview", "style", "handleError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const EchoNextImageClient = _ref => {
  let {
    errorSrc,
    src,
    preview,
    style = {},
    handleError
  } = _ref,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  const {
    0: imgSrc,
    1: setImgSrc
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src);
  const {
    0: visible,
    1: setVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof src === 'string' && src.includes('.heic') && !_utils_is__WEBPACK_IMPORTED_MODULE_3__/* .isSSR */ .yF) {
      // 兼容.heic图片的显示
      __webpack_require__.e(/* import() */ 1616).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23)).then(_ref2 => {
        let {
          default: heic2any
        } = _ref2;

        try {
          fetch(src).then(res => res.blob()).then(blob => heic2any({
            blob
          })).then(conversionResult => {
            const url = URL.createObjectURL(conversionResult);
            setImgSrc(url);
          }).catch(e => {
            console.log('load image src error:', e);
            setImgSrc(errorSrc || _assets_shop2x_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src);
          });
        } catch (error) {
          console.log('fetch error', error);
        }
      });
    } else {
      setImgSrc(src);
    }
  }, [errorSrc, src]);

  if ((0,_utils_is__WEBPACK_IMPORTED_MODULE_3__/* .isBlurValue */ .r7)(src)) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, rest), {}, {
      src: imgSrc,
      style: Object.assign(style, preview ? {
        cursor: 'zoom-in'
      } : {}),
      onLoadingComplete: result => {
        if (result.naturalWidth === 0) {
          errorSrc && setImgSrc(errorSrc);
        }
      },
      onError: () => {
        handleError === null || handleError === void 0 ? void 0 : handleError();
        errorSrc && setImgSrc(errorSrc);
      },
      onClick: preview ? e => {
        e.stopPropagation();
        e.preventDefault();
        setVisible(true);
      } : undefined
    })), preview ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Preview */ .Z.Preview, {
      src: imgSrc,
      visible: visible,
      onVisibleChange: setVisible
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (EchoNextImageClient);

/***/ })

}]);